var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.seasons.length > 0
    ? _c("table", { class: _vm.$style.ratesTable }, [
        _c("thead", [
          _c("tr", [
            _c("th", { attrs: { colspan: "2" } }, [
              _vm._v(
                _vm._s(_vm.seasons.length) +
                  " Season(s) / " +
                  _vm._s(_vm.seasons[0].roomTypes.length) +
                  " Room Type(s)"
              ),
            ]),
            _c(
              "th",
              {
                class: _vm.$style.ratesH,
                attrs: { colspan: _vm.anyDouble && _vm.anyDouble ? 2 : 1 },
              },
              [_vm._v(" Rates / " + _vm._s(_vm.hotel.currency) + " ")]
            ),
          ]),
        ]),
        _c(
          "tbody",
          [
            _vm._l(_vm.seasons, function (season, i) {
              return [
                _c("tr", { key: "h" + i }, [
                  _c("td", [_vm._v("Season")]),
                  _c("td", [_vm._v("RT")]),
                  _vm.anySingle ? _c("td", [_vm._v("Single")]) : _vm._e(),
                  _vm.anyDouble ? _c("td", [_vm._v("Double")]) : _vm._e(),
                ]),
                _c("tr", { key: "b" + i }, [
                  _c("td", { attrs: { rowspan: season.roomTypes.length } }, [
                    _c("div", { class: _vm.$style.seasonLabel }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("calendar_today"),
                      ]),
                      _c("span", [
                        _vm._v(
                          _vm._s(season.start) + " to " + _vm._s(season.end)
                        ),
                      ]),
                    ]),
                  ]),
                  _c("td", [_vm._v("1")]),
                  _vm.anySingle
                    ? _c("td", [_vm._v(_vm._s(season.roomTypes[0].single))])
                    : _vm._e(),
                  _vm.anyDouble
                    ? _c("td", [_vm._v(_vm._s(season.roomTypes[0].double))])
                    : _vm._e(),
                ]),
                _vm._l(season.roomTypes.slice(1), function (rt, iRt) {
                  return _c("tr", { key: "rt" + iRt }, [
                    _c("td", [_vm._v(_vm._s(i + 2))]),
                    _vm.anySingle
                      ? _c("td", [_vm._v(_vm._s(rt.single) + " ")])
                      : _vm._e(),
                    _vm.anyDouble
                      ? _c("td", [_vm._v(_vm._s(rt.double))])
                      : _vm._e(),
                  ])
                }),
              ]
            }),
          ],
          2
        ),
        _vm.hotel.dynamicRate
          ? _c("tfoot", [
              _c("tr", [
                _c("td", { attrs: { colspan: "2" } }, [_vm._v("Dynamic Rate")]),
                _c(
                  "td",
                  {
                    attrs: { colspan: _vm.anyDouble && _vm.anyDouble ? 2 : 1 },
                  },
                  [
                    _vm._v(
                      _vm._s(parseFloat(_vm.hotel.dynamicRate).toFixed(2)) + "%"
                    ),
                  ]
                ),
              ]),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }